import {storeToRefs} from "pinia";
import {useRoute, useRouter} from "vue-router";

import {getSearchParamsFromStore} from "../api/helpers";
import {useSearchStore} from "../store/search";


export const useSubmitSearch = () => {
    const searchStore = useSearchStore();
    const {searchParams, sortingParams, paginateParams} = storeToRefs(searchStore);

    const route = useRoute();
    const router = useRouter();

    const submitSearch = () => {
        searchStore.resetPaginateSortParams();

        const params = doSearch();

        updateUrlQueryParams(params, true);
    }

    const doSearch = () => {

        const params = getSearchParamsFromStore({search_params: searchParams.value, sorting_params: sortingParams.value, paginate_params: paginateParams.value});

        searchStore.search(params);

        return params;
    }

    const handleLayout = layout => {
        searchStore.setDefaultLayout(layout);

        let query = Object.assign({}, route.query);
        query = {...query, layout};
        router.replace({query});
    }

    const handlePerPage = perPage => {
        searchStore.setPaging({page: 1, per_page: perPage});

        const params = doSearch();

        updateUrlQueryParams(params);
    }

    const handleSorting = sortObj => {
        searchStore.setSorting({...sortObj});
        searchStore.setPaging({page: 1, per_page: paginateParams.value.per_page});

        const params = doSearch();

        updateUrlQueryParams(params);
    }

    const handlePaginate = page => {
        searchStore.setPaging({page, per_page: paginateParams.value.per_page});

        const params = doSearch();

        updateUrlQueryParams(params);
    }

    const updateUrlQueryParams = (params, reset = false) => {
        let query = Object.assign({}, route.query);

        if(reset) {
            if(Object.entries(params).length) {
                query = {...params};
                router.replace({query});
            } else {
                router.replace({});
            }

            return;
        }

        if(Object.entries(params).length) {
            query = {...query, ...params};
            router.replace({query});
        } else {
            router.replace({});
        }
    }


    return {
        submitSearch,
        handleLayout,
        handlePerPage,
        handleSorting,
        handlePaginate,
        doSearch
    }
}
